<script setup lang="ts">
defineProps<{
  devOidcOverrideBanner: boolean
}>()
</script>

<template>
  <div
    class="dev-oidc-override-banner"
    :class="{ 'dev-oidc-override-banner--idle': !devOidcOverrideBanner }"
    role="status"
  >
    <span class="dev-oidc-override-banner__text">{{
      devOidcOverrideBanner ? 'Profils OIDC simulés (dev)' : 'Profils OIDC : simulation désactivée (dev)'
    }}</span>
    <span class="dev-oidc-override-banner__sep" aria-hidden="true"> - </span>
    <NuxtLink class="dev-oidc-override-banner__link" to="/dev/oidc-profiles">
      Ouvrir la page Labo « Profils OIDC » pour modifier les rôles
    </NuxtLink>
  </div>
</template>
